import { render, staticRenderFns } from "./VisualCard.vue?vue&type=template&id=9b5d2d84&scoped=true"
var script = {}
import style0 from "./VisualCard.vue?vue&type=style&index=0&id=9b5d2d84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b5d2d84",
  null
  
)

export default component.exports